import r from "./main7.js";
import a from "./main8.js";
function i(t, e, o) {
  a(t, e, o);
}
function m(t, e, o) {
  return r(t, e, o);
}
export {
  m as getMetadata,
  i as setMetadata
};
